export default __webpack_public_path__ + "static/media/foto-perfil.3331805b.jpeg";